import React from "react";

export default function CollapsibleMobileCard({
    expanded = false,
    editing = false,
    onToggle,
    title,
    meta = null,
    preview = null,
    badge = null,
    actions = null,
    children,
}) {
    const isOpen = expanded || editing;

    return (
        <div
            className={`config-card collapsible-card ${isOpen ? "is-expanded" : ""} ${editing ? "is-editing" : ""}`}
            onClick={() => {
                if (editing) return;
                onToggle?.();
            }}
            onKeyDown={(event) => {
                if (editing) return;
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onToggle?.();
                }
            }}
            role="button"
            tabIndex={0}
            aria-expanded={isOpen}
        >
            <div className="collapsible-card__top">
                <div className="collapsible-card__main">
                    <div className="collapsible-card__title-row">
                        <h3 className="collapsible-card__title">{title}</h3>
                        <span className="collapsible-card__chevron" aria-hidden="true">
                            {isOpen ? "▲" : "▼"}
                        </span>
                    </div>
                    {(meta || badge) ? (
                        <div className="collapsible-card__meta">
                            {meta}
                            {badge}
                        </div>
                    ) : null}
                    {!isOpen && preview ? (
                        <div className="collapsible-card__preview">{preview}</div>
                    ) : null}
                </div>
                {actions ? (
                    <div className="collapsible-card__actions" onClick={(event) => event.stopPropagation()}>
                        {actions}
                    </div>
                ) : null}
            </div>
            {isOpen ? (
                <div
                    className="collapsible-card__body"
                    onClick={(event) => {
                        if (editing) event.stopPropagation();
                    }}
                >
                    {children}
                </div>
            ) : null}
        </div>
    );
}
